import { useContext, useEffect } from 'react';

import axios from 'axios';
import ErrorState from 'components/layout/error-state/error-state';
import LoadingOlist from 'components/layout/loading-olist';
import { sendGTMEvent } from 'helpers/google-tag-manager';
import LeadsHeader from 'pages/leads/components/leads-header/leads-header';
import UnqualifiedCardsList from 'pages/leads/components/unqualified-cards-list/unqualified-cards-list';
import UnqualifiedChangeButton from 'pages/leads/components/unqualified-change-button/unqualified-change-button';
import UnqualifiedMessage from 'pages/leads/components/unqualified-message/unqualified-message';
import { useTranslation } from 'react-i18next';
import { useAsyncFn } from 'react-use';

import { Container } from '@olist/templates';
import { Box, Flex, Relative, Text } from '@olist/united';

import { RootContext } from '../../components/leads-provider';
import { API_URLS } from '../../constants';
import { transformUnqualifiedItems } from '../../utils';
import { UnqualifedLinkHelp } from './unqualified-page.style';

const UnqualifiedPage = () => {
  const { t } = useTranslation();

  const { appUrls, leadIdCookie, leadProfileCookie } = useContext(RootContext);

  const [{ error, loading, value: unqualifiedData }, fetchUnqualifiedData] = useAsyncFn(
    async () => axios.get(API_URLS.getUnqualifiedProfile({ leadId: leadIdCookie })),
    []
  );

  useEffect(() => {
    fetchUnqualifiedData();
  }, [fetchUnqualifiedData]);

  useEffect(() => {
    sendGTMEvent('page_view', {
      user_id: leadProfileCookie?.email,
    });
  }, [leadProfileCookie]);

  if (error) {
    return (
      <Flex height="100vh" justifyContent="center" alignItems="center">
        <ErrorState onClick={() => window.location.reload()} />
      </Flex>
    );
  }

  if (loading || !unqualifiedData) {
    return <LoadingOlist />;
  }

  const { data: qualificationProfile } = unqualifiedData;
  const unqualifiedItems = transformUnqualifiedItems(qualificationProfile);

  return (
    <Container>
      <LeadsHeader currentStep={LeadsHeader.steps.REQUIREMENTS} />
      <Flex as={Relative} flexDirection={['column', 'column', 'row']}>
        <Flex flexDirection="column" alignItems="flex-start" width={1}>
          <Flex flexDirection="column" textAlign="left" maxWidth="600px" mt={2}>
            <Box>
              <Text.H3 display="inline-block" weight="semi-bold">
                {t`Wow, we still can't close a partnership`} 😕
              </Text.H3>{' '}
            </Box>
            <UnqualifiedMessage />
            <UnqualifiedCardsList
              items={unqualifiedItems}
              qualificationProfile={qualificationProfile}
            />
            <div>
              {t`Doubts`}?{' '}
              <UnqualifedLinkHelp
                target="_blank"
                href="https://ajuda.olist.com/hc/pt-br/articles/4409254432148?_ga=2.226183385.2107032342.1657216537-1424144663.1657216537"
                rel="noreferrer"
              >
                {t`Find out how we can help you`}
              </UnqualifedLinkHelp>
            </div>
            <br />
            <UnqualifiedChangeButton to={appUrls.REQUISITES_URL} />
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};

export default UnqualifiedPage;
